<!-- eslint-disable vue/no-mutating-props -->
<template>
    <div class="row-container"
         @keydown.enter="saveLinkWithKeyCombo($event)">

    <div class="row">
        <div class="col-sm-8 col-12">
            <div class="form-label-group">
                <textarea id="title" name="title" type="text" class="form-control" v-model="title" />
                <label for="title">Title</label>
            </div>
            <div class="form-label-group">
                <input id="url" name="url" type="text" class="form-control" v-model="url"/>
                <label class="" for="url">Website address</label>
            </div>
        </div>

        <div class="d-none d-sm-block col-sm-4">
            <img ref="previewImage"
                 :src="previewImageUrl || '/broken_image_placeholder_small2.png'"
                 class="previewImage previewImage__noPointer p-0 m-0 mt-2 img-thumbnail"
                 alt="Preview"
                 onerror="if (this.src != '/broken_image_placeholder_small2.png') this.src = '/broken_image_placeholder_small2.png'"/>
            <div class="reloadBtn" data-toggle="tooltip" title="reload preview image">
                <a @click="reload">
                    <i class="bi icon-grow bi-arrow-clockwise"></i>
                </a>
            </div>
        </div>
    </div>

    <div class="form-label-group">
        <input id="tags" name="tags" type="text" class="tagify-tags-input" @change="onTagsChanged($event)"/>
        <label class="" for="tags">Tags (start typing for autocomplete)</label>
    </div>

    <div class="input-group mb-3">

        <div class="custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="visibilitySwitch" v-model="isPrivate"/>
            <label class="custom-control-label" for="visibilitySwitch">Make this bookmark private</label>
        </div>
    </div>
    <div class="row pt-1">
        <div class="col-12">
            <spinner-button
                    :spinning="saveInProgress"
                    @click="saveLink()"
                    class="float-right btn btn-success">Save bookmark

            </spinner-button>
        </div>
    </div>
    </div>
</template>
<script>
/* eslint-disable vue/no-mutating-props */
import BackendClient from "@/rest/backend-client";
import Tagify from '@yaireo/tagify'
import '@yaireo/tagify/dist/tagify.css'
import SpinnerButton from "@/components/SpinnerButton";

const LOAD_METADATA_MODE_AUTO = 'auto';
const LOAD_METADATA_MODE_OFF = 'off';

export default {
  name: "EmbeddedForm",
  components: { SpinnerButton },
  props: ["defaultTitle", "defaultUrl", "defaultTags", "defaultVisibility", "defaultSuggestedTags", "defaultPreviewImageUrl", "loadMetadata", "saveInProgress"],
  data() {
    return {
        backendClient: new BackendClient(),
        lastTagsSeparated: null,
        url: this.defaultUrl,
        title: this.defaultTitle || null,
        suggestedTags: this.defaultSuggestedTags || null,
        tags: this.defaultTags ? [...this.defaultTags] : [],
        visibility: this.defaultVisibility || 'PUBLIC',
        previewImageUrl: this.defaultPreviewImageUrl || null,
        tagify: {}
    }
  },

  mounted() {
    if (!this.url) {
        return;
    }

    this.initializeBootstrapComponents();

    this.backendClient.refreshTagCountsIfNeeded().then(() => {
        this.refreshTagifyWhiteList();
    });

    const titleWasPreloaded = !!this.title;
    const suggestedTagsWerePreloaded = !!this.suggestedTags;

    this.initTagify();

    if (this.loadMetadata === LOAD_METADATA_MODE_OFF){
        return;
    }

    if (this.loadMetadata === LOAD_METADATA_MODE_AUTO && (!titleWasPreloaded || !this.suggestedTags || !this.previewImageUrl)) {
        if (!titleWasPreloaded) {
            this.title = "Loading title...";
        }
        this.backendClient.fetchExternalMetadata(this.url).then(response => {
            if (!this.previewImageUrl) {
                this.previewImageUrl = response.previewImageUrl;
            }
            if (!titleWasPreloaded) {
                this.title = response.title;
            }
            if (!suggestedTagsWerePreloaded) {
                this.suggestedTags = response.suggestedTags;
                this.refreshTagifyWhiteList();
            }
        })
    }
  },
  computed: {
    isPrivate: {
      get() {
        return this.visibility == 'PRIVATE';
      },
      set(newValue) {
        this.visibility = newValue? 'PRIVATE': 'PUBLIC';
      }
    }
  },
  methods: {
     initializeBootstrapComponents() {
      // eslint-disable-next-line
      $(function () {
        // eslint-disable-next-line
        $('[data-toggle="tooltip"]').tooltip()
      })
    },
    reload() {
        this.previewImageUrl = "/broken_image_placeholder_small2.png";
        this.backendClient.fetchExternalMetadata(this.url).then(response => {
            if (response.previewImageUrl) {
                this.previewImageUrl = response.previewImageUrl;
            }
        })
    },
    saveLinkWithKeyCombo(e) {
        if (e.key == 'Enter' &&
              (e.ctrlKey == true || e.metaKey == true) &&
              !this.tagify.state.inputText &&
              !this.tagify.state.editing &&
              !this.tagify.state.dropdown.visible){
            setTimeout(this.saveLink())
          }
    },
    saveLink() {
      if (!this.url || this.url === "" || !this.title || this.title === "") {
        this.$store.commit("addError", "Please add an url and title!");
        return;
      }

      let tagsValidationResult;
      const tagValues = this.tags ? this.tags.map(tag => tag.value) : null;
      if (tagValues){
        tagsValidationResult = this.validateTags(tagValues);
        if (!tagsValidationResult.valid) {
          this.$store.commit("addError", "Each tag must contain only letters, digits, spaces, or underscores!");
          return;
        }
      }

      this.$emit('saved', {
        title: this.title,
        url: this.url,
        tags: tagValues ? tagsValidationResult.validItems : [],
        visibility: this.isPrivate? 'PRIVATE': 'PUBLIC',
        previewImageUrl: this.previewImageUrl } );
    },
    validateTags(input) {
      const pattern = /^[\p{L}0-9 _]+$/u;

      const invalidItems = input.filter(item => !pattern.test(item));

      return {
        valid: invalidItems.length === 0,
        validItems: input.filter(item => pattern.test(item)),
        invalidItems: invalidItems
      }
    },
    getValidatedSuggestedTags() {
        if (!this.suggestedTags) {
            return [];
        }
        const validationResult = this.validateTags(this.suggestedTags);
        if (!validationResult.valid) {
            console.log("invalid suggested tags", validationResult.invalidItems)
        }
        return validationResult.validItems;
    },
    onTagsChanged(e) {
        const newValue = e.target.value ? JSON.parse(e.target.value): [];
        this.tags.splice(0, Infinity, ...newValue);
    },
    getOwnedTags() {
        let tags = this.$store.state.ownedTags.tags;
        if (!tags) {
            return [];
        }
        return Object.entries(tags)
            .sort((e1, e2) => e2[1] - e1[1])
            .map(e => e[0])
    },
    initTagify() {
        const inputElem = document.querySelector('#tags')
        this.tagify = new Tagify(inputElem, {
            whitelist: [],
            editTags: {
                keepInvalid: true
            },
            pattern: /^[\p{L}0-9 _]+$/u,
            dropdown: {
              maxItems: 12,
              classname: "tags-look",
              enabled: 0,
              closeOnSelect: false
            }
        });

        this.tagify.addTags([...this.tags]);
    },
    refreshTagifyWhiteList() {
        const allTags = [...this.getValidatedSuggestedTags(), ...this.getOwnedTags()]
        this.tagify.whitelist = [...new Set(allTags)];
    }
  }
}
</script>

<style>

.previewImage__noPointer {
  cursor: unset !important;
}

.tagify-tags-input {
    --tag-bg: #ffc107;
    --tag-border-radius: 0.25rem;
    --tag-pad: .25em .4em;

    font-weight: 700;
    width: 100%;
    border: 1px lightgray solid;
    padding-top: 1.5rem;
    padding-bottom: .5rem;
    padding-left: .3rem;
    padding-right: .3rem;
    border-radius: 0.25rem;
    background-color: #fff;
}

.tagify__tag-text::before, .tagify__dropdown__item::before {
    content: "#";
    opacity: 0.8;
}

.tags-look .tagify__dropdown__item{
    display: inline-block;
    vertical-align: middle;
    border-radius: 0.25rem;
    padding: .25em .4em;
    background: #007bff;
    margin: .2em;
    font-weight: 700;
    color: white;
    transition: 0s;
}

.tagify__dropdown {
    border: 1px solid lightgray;
    border-radius: 0.25rem;
}

.tagify__dropdown__wrapper {
    border:none;
    padding-left: .75rem;
}

.tagify__dropdown__wrapper::before {
    content: "Suggestions:";
    font-size: 12px;
    font-weight: 400

}

.tags-look .tagify__dropdown__item:hover{
    opacity: 70%;

}

.tags-look .tagify__dropdown__item--hidden {
    max-width: 0;
    max-height: initial;
    padding: .3em 0;
    margin: .2em 0;
    white-space: nowrap;
    text-indent: -20px;
    border: 0;
}

.form-label-group {
    position: relative;
    margin-bottom: 1rem;
}

.form-label-group input,
.form-label-group label {
  height: 3.125rem;
  padding: .75rem;
}
.form-label-group textarea {
    height: 5rem;
    padding-top: .75rem;
}

.form-label-group label {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  margin-bottom: 0;
  line-height: 1.5;
  color: #495057;
  pointer-events: none;
  cursor: text;
  border: 1px solid transparent;
  border-radius: .25rem;
  transition: all .1s ease-in-out;
}




.form-label-group input, .form-label-group textarea {
  padding-top: 1.25rem;
  padding-bottom: .25rem;
}

.form-label-group input ~ label, .form-label-group textarea ~ label {
  padding-top: .25rem;
  padding-bottom: .25rem;
  font-size: 12px;
  color: #777;
}

.reloadBtn {
    display:none;
    position: absolute;
    top: 13px;
    left: 20px;
    background: lightgray;
    color: black;
    padding: 1px;
    width: 25px;
    text-align: center;
    cursor: pointer;
    border-radius: 3px;
}



</style>